import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=4f3f2a54&scoped=true&lang=pug"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"
import style0 from "./swiper.vue?vue&type=style&index=0&id=4f3f2a54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3f2a54",
  null
  
)

export default component.exports